module.exports = __webpack_public_path__ + "img/Logo.5b0dd641.svg";